unit UStampList;

interface

uses
  System.Contnrs, UStampModel, UEssentialHelper;

type
  TStampList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    FOnError: TErrorEvent;
    function GetItem(i: Integer): TStampModel;
    procedure AddRange(json: string);
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create;
    procedure Add(item: TStampModel);
    procedure GetLastStamps(url: string; personalNr: string;
      stampCount: Integer; stampArt: TStampArt);
    property Items[i: Integer]: TStampModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  Js, WebLib.json, WebLib.REST, System.SysUtils, WebLib.Controls, WebLib.Storage;

{ TStampList }

procedure TStampList.Add(item: TStampModel);
begin
  inherited Add(item);
end;

procedure TStampList.AddRange(json: string);
var
  obj: TJsObject;
  i, count: Integer;
begin
  Self.Clear;
  obj := TJsJson.parseObject(json);
  if obj['Count'] <> nil then
  begin
    count := StrToInt(string(obj['Count']));
    for i := 0 to count - 1 do
    begin
      if obj['Item' + IntToStr(i)] <> nil then
      begin
        Self.Add(TStampModel.Create(string(obj['Item' + IntToStr(i)])));
      end;
    end;
  end;
end;

constructor TStampList.Create;
begin
  inherited Create;
  Self.OnPropertyChanged := nil;
  Self.OnError := nil;
end;

procedure TStampList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

function TStampList.GetItem(i: Integer): TStampModel;
begin
  Result := inherited GetItem(i) as TStampModel;
end;

procedure TStampList.GetLastStamps(url: string; personalNr: string;
  stampCount: Integer; stampArt: TStampArt);
var
  obj: TJsonObject;
  s, cmd: string;
  client: TRestClient;
  procedure Response(Sender: TObject; AResponse: string);
  var
    jso: TJsObject;
  begin
    if AResponse<>'' then
      TLocalStorage.SetValue(cmd,AResponse)
    else
      AResponse:=TLocalStorage.GetValue(cmd);
    if AResponse<>'' then begin
    jso := TJsJson.parseObject(AResponse);
    if jso['value'] <> nil then
      Self.AddRange(string(jso['value']));
    Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TStampList.GetLastStamps');
  end;

  procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', personalNr);
  cmd := url + '/StampService/GetLastStamps_' + obj.ToString;
  obj.AddPair('StampCount', IntToStr(stampCount));
  obj.AddPair('StampArt', StampArtToStr(stampArt));
  s := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', s);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(url + '/StampService/GetLastStamps', 'application/json',
    obj.ToString);
end;

procedure TStampList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TStampList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TStampList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

end.
